
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11874',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11874",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.305",
  "data-fetching-client": "static-1.9561",
  "foundations-components": "static-1.7691",
  "foundations-components-legacy": "static-1.716",
  "foundations-theming": "static-1.4297",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.79",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7897",
  "hub-http-shared-msw-handlers": "static-1.9698",
  "hubspot-dlb": "static-2.1828",
  "hubspot-url-utils": "static-1.4034",
  "HubStyleTokens": "static-2-me-set-font-family-mixin.4",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6356",
  "marketplace-storefront-base": "static-1.11935",
  "quartz": "static-1.6848",
  "react-dlb": "static-1.75",
  "react-rhumb": "static-1.16540",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2748",
  "reporting-testing-lib": "static-1.8877",
  "settings-ui-lib": "static-1.12411",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6923",
  "ui-addon-i18n": "static-1.11032",
  "ui-addon-react-router-dom": "static-1.9430",
  "unified-auth": "static-1.328",
  "unified-auth-core-lib": "static-1.609",
  "usage-tracker": "static-1.7221",
  "usage-tracker-core": "static-1.7071",
  "customer-data-property-utils": "static-1.7969",
  "history": "static-4.47",
  "hub-http": "static-1.6105",
  "integrations-lib": "static-1.15723",
  "marketplace-ui-common": "static-1.19244",
  "property-management-iframe": "static-1.12750",
  "quartz-config": "static-1.626",
  "quartz-core": "static-1.6067",
  "quartz-routing": "static-1.278",
  "quick-fetch": "static-1.3819",
  "react": "static-7.183",
  "rpc-client-utils": "static-1.4529",
  "ts-schema": "static-1.3983",
  "ui-universal-auth": "static-1.8814",
  "UIComponents": "static-3-me-set-font-family-mixin.4",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.425",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven": "static-3.5808",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3309",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3125",
  "quartz-webpack": "static-1.3072",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3960",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4730",
  "foundations-theming-specialty": "static-1.2013",
  "framer-motion": "static-1.69",
  "hs-story-utils": "static-1.9314",
  "react-aria": "static-1.63",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5252",
  "react-virtualized": "static-2.96",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1481",
  "ui-fonts": "static-1-me-set-font-family-mixin.4",
  "ui-images": "static-2-me-set-font-family-mixin.2",
  "bend-plugin-foundations-theming": "static-1.2780",
  "foundations-theming-base": "static-1.3282",
  "stylex": "static-1.29",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.3008",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4210",
  "ai-components-ui-library": "static-1.8633",
  "ai-rendering-library": "static-1.9644",
  "chirp-fetch": "static-1.1767",
  "connections-embed-lib": "static-1.772",
  "copilot-toolkit": "static-1.10798",
  "laboratory-lib": "static-3.7045",
  "marketplace-embed": "static-1.21737",
  "marketplace-ui-details": "static-1.9140",
  "marketplace-ui-reviews": "static-1.19200",
  "marketplace-ui-tracking": "static-1.13415",
  "sanitize-text": "static-1.8030",
  "ui-addon-video-player": "static-1.8581",
  "usage-tracker-multi": "static-1.5635",
  "usage-tracker-session-replay": "static-1.4907",
  "wootric-nps": "static-1.6870",
  "apollo-link-hub-http": "static-2.4536",
  "immer": "static-1.33",
  "immerable": "static-1.4038",
  "highcharts": "static-8.101",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2427",
  "reporting-data": "static-1.66944",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2-me-set-font-family-mixin.4",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10095",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10259",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7211",
  "icons": "static-2-me-set-font-family-mixin.2",
  "marketplace-ui-apps-core": "static-1.17777",
  "storybook-react": "static-1.30",
  "trellis-story-utils": "static-1.4405",
  "foundations-components-test-utils": "static-1.5174",
  "quartz-i18n": "static-1.523",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3619",
  "customer-data-objects": "static-1.7540",
  "property-translator": "static-1.5295",
  "frontend-preferences-client": "static-1.7810",
  "hs-promise-utils": "static-1.5481",
  "hubspot-apollo-client": "static-1.4764",
  "integrations-error-boundary-lib": "static-1.13138",
  "integrations-tracking-lib": "static-1.5481",
  "native-integrations-shared-strings": "static-1.7672",
  "reselect": "static-2.16",
  "sanitize": "static-1.4358",
  "superstore": "static-1.4654",
  "ui-shepherd-react": "static-3.10032",
  "ai-settings-ui-library": "static-1.7696",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4556",
  "immutable-less": "static-1.4538",
  "marketplace-ui-client-types": "static-1.16651",
  "nav-meta": "static-1.29233",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10130",
  "ui-addon-upgrades": "static-9.17810",
  "inbound-db-properties-service-client": "static-1.3750",
  "property-management-common": "static-1.5038",
  "ui-addon-iframeable": "static-1.8935",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.523",
  "quartz-head": "static-1.513",
  "quartz-test": "static-1.523",
  "quartz-tracking": "static-1.227",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3053",
  "sassPrefix": "static-1.153",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20754",
  "ContentUtils": "static-1.67964",
  "avatar-components": "static-1.2380",
  "customer-data-filters-ui": "static-1.39272",
  "customer-data-objects-ui-components": "static-1.12903",
  "customer-data-reference-ui-components": "static-1.13039",
  "embedded-academy-lib": "static-1.13905",
  "ExportDialog": "static-6.10275",
  "highlight.js": "static-1.76",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40927",
  "reporting-snowflake": "static-1.55562",
  "reporting-ui-components": "static-2.64215",
  "reporting-visualizations": "static-1.59020",
  "ui-addon-teams": "static-1.21386",
  "magpie-lib": "static-1.5479",
  "magpie-types": "static-1.4939",
  "simple-logging-lib": "static-1.2936",
  "navigation-components": "static-1.17596",
  "ai-studio-lib": "static-1.11263",
  "app-governance-lib": "static-1.1177",
  "developer-experience-shared-components": "static-1.10391",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7876",
  "ui-product-approvals": "static-1.27793",
  "ui-tool-access": "static-1.10032",
  "usage-based-billing-components-lib": "static-1.8279",
  "usage-tracker-anonymous": "static-1.5638",
  "usage-tracker-public": "static-1.7032",
  "amplitude-session-replay-browser": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3494",
  "persist-promise": "static-1.3594",
  "reference-resolvers": "static-1.8052",
  "ui-extensibility-client-types": "static-1.3825",
  "hubspot-apollo-cache": "static-1.223",
  "universal-page-editor-lib": "static-1.2892",
  "final-form": "static-1.67",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2443",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4955",
  "purchase-motions-components": "static-1.5653",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1437",
  "crm-component-utils": "static-1.38737",
  "crm-properties-common-lib": "static-1.5761",
  "customer-data-properties": "static-1.51123",
  "framework-data-schema-resolvers": "static-1.6761",
  "property-value-citations": "static-1.1737",
  "reference-resolvers-lite": "static-1.7975",
  "navigation-messaging": "static-1.6923",
  "hubspotter-http-shared-msw-handlers": "static-1.9696",
  "cms-field-types": "static-1.4694",
  "content-icons-ui": "static-1.2191",
  "conversations-skeleton-state": "static-1.7134",
  "crm-message-bus": "static-1.42646",
  "customer-data-filters-ui-msw-helpers": "static-1.21707",
  "customer-data-ui-utilities": "static-1.9710",
  "FormUrlGenerator": "static-2.4605",
  "framework-builder-read-service-client": "static-1.3913",
  "framework-data-schema-quick-fetch": "static-1.6666",
  "multi-account-reference-resolvers": "static-1.869",
  "onboarding-tours": "static-1.16392",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13336",
  "academy-common-lib": "static-1.13365",
  "content-assistance-lib": "static-1.7580",
  "dashboard-lib": "static-1.81022",
  "file-manager-components": "static-1.23243",
  "getting-started-shared-tasks": "static-1.18156",
  "hubspot-prosemirror": "static-1.17889",
  "hubspot-prosemirror-plugins": "static-1.17881",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19633",
  "share-with-third-party-component-lib": "static-1.8579",
  "ui-addon-draggable": "static-3.4654",
  "ui-asset-management-lib": "static-1.10854",
  "ui-business-units-lib": "static-1.8925",
  "user-context": "static-1.4985",
  "growth-payments-core": "static-1.25007",
  "reporting-plugins": "static-1.10115",
  "reporting-reports": "static-1.66622",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.609",
  "nest": "static-1.107",
  "codemirror": "static-5.92",
  "feedback-loader": "static-1.29074",
  "react-codemirror": "static-1.10509",
  "framework-listing-lib": "static-2.28317",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30387",
  "apps-service-types": "static-1.3763",
  "oauth-service-types": "static-1.4134",
  "onboarding-scopes": "static-1.6348",
  "onboarding-tours-client": "static-1.4606",
  "platform-infra-nav-components": "static-1.7571",
  "subscription-experience-data-types": "static-1.14708",
  "crm-record-cards-service-types": "static-1.3515",
  "location-customization-utils-lib": "static-1.8862",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4386",
  "nav-client-types": "static-1.2244",
  "purchase-motions-api": "static-1.5656",
  "signup-constants": "static-1.18625",
  "signup-ui-url-generator": "static-2.7925",
  "trials-service-types": "static-1.3787",
  "card-properties-lib": "static-1.43808",
  "commerce-subscription-lib": "static-1.36747",
  "crm-actions": "static-1.6200",
  "crm-cards-sdk": "static-1.43214",
  "customer-data-properties-shared-msw-handlers": "static-1.9025",
  "customer-data-tracking": "static-1.6768",
  "hs-resources": "static-1.21",
  "pulse": "static-1.419",
  "calling-global-api": "static-1.64043",
  "calling-internal-common": "static-1.31187",
  "calling-lifecycle-internal": "static-1.65425",
  "calling-lifecycle-messages": "static-1.57719",
  "commerce-products-lib": "static-1.9110",
  "conditional-properties-service-client": "static-1.3702",
  "crm-links": "static-1.6160",
  "external-options-client-types": "static-1.4063",
  "google-libphonenumber": "static-1.35",
  "inbounddb-objects-service-types": "static-1.4127",
  "meetings-icalendar-utils-lib": "static-1.516",
  "multi-currency-client-types": "static-1.3594",
  "object-builder-ui-client": "static-1.48339",
  "pipeline-validation-client-types": "static-1.3869",
  "smart-property-lib": "static-1.6369",
  "tiered-pricing": "static-1.987",
  "ui-addon-form-validation": "static-1.10877",
  "crm-pipelines-api-client-types": "static-1.4047",
  "react-dnd-compat": "static-1.4504",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5252",
  "growth-onboarding-confetti": "static-1.2957",
  "growth-onboarding-next-action-utils": "static-1.1564",
  "onboarding-tours-utils": "static-1.458",
  "ui-shepherd-tracker": "static-1.7413",
  "academy-service-client": "static-1.3566",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28203",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8268",
  "video-components-external": "static-1.10885",
  "video-data-lib": "static-1.34543",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23194",
  "ui-addon-emoji-picker": "static-1.9772",
  "EmailSignatureEditor": "static-1.24109",
  "viral-links-lib": "static-1.6923",
  "data-token-picker": "static-1.16204",
  "FileManagerLib": "static-1.38883",
  "react-flip-move": "static-1.67",
  "timezone-utils": "static-2.5129",
  "getting-started-shared-tasks-store": "static-1.17274",
  "campaign-roi-lib": "static-1.8582",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7209",
  "customer-data-views-management": "static-1.25186",
  "framework-data-table": "static-2.11634",
  "marketing-platform-lib": "static-1.6735",
  "nudge-client-utils": "static-1.2332",
  "nudge-custom-ui-functions": "static-1.828",
  "app-users-service-client": "static-1.5441",
  "app-users-service-types": "static-1.4849",
  "mini-checkout-client": "static-1.26530",
  "onboarding-utils": "static-1.5236",
  "permissions-shared-i18n-strings-fe": "static-1.1998",
  "ui-coaching-tips-shared-config": "static-1.28188",
  "edison-service-client-types": "static-1.273",
  "eligibility-engine-service-types": "static-1.3068",
  "crm_data": "static-4.91570",
  "customer-data-sidebar": "static-2.45675",
  "enrichment-properties-lib": "static-1.15487",
  "commerce-billing-lib": "static-1.18750",
  "commerce-shared-components-lib": "static-1.18212",
  "commerce-tools-ui-lib": "static-1.10061",
  "crm-fe-perf": "static-1.22788",
  "directed-graph": "static-1.823",
  "event-emitter": "static-1.833",
  "fast-json-patch": "static-1.60",
  "calling-error-reporting": "static-1.31193",
  "shared-worker-versioning": "static-1.10924",
  "calling-usage-tracker": "static-1.6427",
  "voice-sms-access-library": "static-1.541",
  "commerce-permissions": "static-1.650",
  "products-iframe-lib": "static-1.7597",
  "products-ui-components-shared-msw-handlers": "static-1.10080",
  "breeze-intelligence-kit": "static-1.5454",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9781",
  "policy-lib": "static-1.6669",
  "react-tinymce": "static-1.54897",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9844",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54023",
  "tinymce-plugins": "static-1.57137",
  "tinymce-themes": "static-1.55993",
  "onboarding-data-sync-lib": "static-1.1768",
  "growth-onboarding-next-action-components": "static-1.1592",
  "user-context-client": "static-1.4497",
  "growth-onboarding-feedback-components": "static-1.6466",
  "content-media-composition-data-lib": "static-1.11842",
  "content-media-compositions": "static-2.15849",
  "media-bridge-lib": "static-1.18724",
  "commerce-tours-lib": "static-1.5882",
  "growth-onboarding-reliability": "static-1.4972",
  "sales-checkout-service-client": "static-1.3554",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21472",
  "sales-email-signature-service-client": "static-1.3729",
  "audio-components": "static-1.5743",
  "FileManagerCore": "static-1.38742",
  "FileManagerImages": "static-1.36394",
  "video-components": "static-1.12888",
  "crm-export-dialog": "static-1.6180",
  "crm-index-associations-lib": "static-1.6322",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1584",
  "tanstack-virtual": "static-1.27",
  "nudge-custom-function-registry": "static-1.2089",
  "nudge-renderer-utils": "static-1.2408",
  "whisper-core-api": "static-1.6252",
  "InboxConnectUtils": "static-4.14480",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5261",
  "settings-content-modals": "static-1.45734",
  "crm_universal": "static-1.21805",
  "customer-data-email": "static-1.17834",
  "card-payment-highlight-lib": "static-1.36791",
  "card-subscription-highlight-lib": "static-1.39170",
  "commerce-contract-lib": "static-1.11539",
  "invoices-highlight-card-lib": "static-1.54319",
  "orders-highlight-card-lib": "static-1.21124",
  "products-highlight-card-lib": "static-1.17394",
  "quotes-highlight-card-lib": "static-1.71535",
  "crm-source-interpretation-lib": "static-1.5219",
  "utility-belt": "static-1.2425",
  "payments-enrollment-embed-lib": "static-1.22286",
  "stripe-embedded-components": "static-1.7303",
  "customer-data-rte": "static-1.32687",
  "cv-backend-services": "static-1.1536",
  "growth-onboarding-empty-states": "static-1.5505",
  "payments-post-enroll-local-storage-lib": "static-1.4997",
  "qrcode-generator": "static-1.66",
  "quotes-client-types": "static-1.37625",
  "calling-orchestration-schema": "static-1.35318",
  "sales-views-client-types": "static-1.4149",
  "hub-http-contrib": "static-1.2928",
  "interframe": "static-3.4648",
  "tinymce-data": "static-1.40108",
  "ui-addon-sales-email": "static-1.5097",
  "layout-dnd-components": "static-1.12223",
  "layout-dnd-utils": "static-1.11198",
  "ui-brand-identity-lib": "static-1.14671",
  "NamespacedHubStyle": "static-2.8973",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4417",
  "video-embed": "static-1.35377",
  "social-insights-client-types": "static-1.21716",
  "deal-intel-utils": "static-1.1588",
  "checkout-sdk": "static-3.23373",
  "checkout-service-types": "static-1.3731",
  "company-details-components": "static-1.6072",
  "payment-method-components": "static-1.6783",
  "pricing-pages-ui-components": "static-1.13169",
  "quote-checkout-service-types": "static-1.3366",
  "upgrade-catalog-service-types": "static-1.3412",
  "access-control-lib": "static-1.10323",
  "EmailComponents": "static-1.54417",
  "EmailData": "static-1.53094",
  "redux-less": "static-2.9370",
  "sequences-lib": "static-1.7844",
  "ui-gdpr-components": "static-1.10234",
  "products-ui-components": "static-1.39629",
  "quotes-ui-lib": "static-1.80256",
  "accounting-integrations-ui-components": "static-1.6878",
  "invoices-ui-lib": "static-1.54335",
  "commerce-products-api": "static-1.2112",
  "invoices-iframe-lib": "static-1.56393",
  "quotes-modal-lib": "static-1.102213",
  "stripe-connect-js": "static-1.66",
  "draft-content-plugins": "static-1.27955",
  "ContentData": "static-1.68039",
  "layout-data-lib": "static-1.9523",
  "outpost": "static-1.4082",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3815",
  "billing-payments-client-types": "static-1.3874",
  "account-and-billing-fintech-outages": "static-3.18362",
  "pricing-pages-api": "static-1.13034",
  "ContentComponents": "static-2.70920",
  "marketing-contacts-lib": "static-1.9450",
  "marketing-email-service-types": "static-1.1834",
  "messaging-editing-lib": "static-1.45895",
  "messaging-usage-based-billing-components-lib": "static-1.757",
  "automation-ui-source-apps": "static-1.18512",
  "automation-ui-types": "static-1.19430",
  "messaging-types-lib": "static-1.45632",
  "onboarding-settings-client": "static-1.4389",
  "sequences-client-types-lib": "static-1.7701",
  "commerce-tax-lib": "static-1.405",
  "property-description-translator": "static-1.3740",
  "SalesContentIndexUI": "static-3.9060",
  "commerce-analytics-service-client": "static-1.3542",
  "totals-ui-components": "static-1.23242",
  "advanced-menus-core": "static-1.14950",
  "advanced-menus-lib": "static-1.11914",
  "ui-memberships-settings-lib": "static-1.33712",
  "demographics-service-types": "static-1.1536",
  "automation-ui-ubb": "static-1.5346",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7225",
  "data-token-views": "static-1.16185",
  "forms-utils-lib": "static-1.12361",
  "payments-embed-points-lib": "static-1.12801",
  "simple-menus-core": "static-1.14949",
  "simple-menus-lib": "static-1.16466",
  "ui-addon-draggable-compat": "static-2.4139",
  "videoconference-integration-components": "static-1.6655",
  "automation-applications-service-types": "static-1.3406",
  "automation-platform-service-types": "static-1.2548",
  "ContentEditorUI": "static-2.76782",
  "short-messages-app-service-client": "static-1.3873",
  "web-interactives-components": "static-1.13564",
  "web-interactives-data": "static-1.13565",
  "messaging-shared-utils-lib": "static-1.206",
  "messaging-user-info-utils-lib": "static-1.376",
  "email-portal-health-service-types": "static-1.862",
  "FireAlarmUi": "static-1.4414",
  "sales-templates-service-types-lib": "static-1.4071",
  "commerce-totals-service-types": "static-1.3721",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21366",
  "automation-ui-usage-tracking": "static-1.20829",
  "data-studio-ubb": "static-1.2380",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26680",
  "collaboration-sidebar": "static-1.57416",
  "content-management-data-lib": "static-1.5240",
  "copilot-plugins": "static-1.10771",
  "cta-picker": "static-1.36089",
  "customer-agent-discovery-components-lib": "static-1.2714",
  "editor-components": "static-1.13064",
  "editor-iframe-lib": "static-1.8244",
  "error-messaging-js": "static-1.5076",
  "FormsCommonComponents": "static-1.85530",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.62",
  "redux-request-state": "static-1.10531",
  "SharedLegalStrings": "static-1.1638",
  "smart-content-core": "static-1.42116",
  "smart-content-lib": "static-1.42769",
  "social-composer-lib": "static-1.58506",
  "structured-content-lib": "static-1.24871",
  "theme-previewer-lib": "static-1.52925",
  "tinymce-copilot": "static-1.16091",
  "xray-recommendation-lib": "static-1.7735",
  "automation-ui-routing": "static-1.20787",
  "sql-reporting-client-types": "static-1.5550",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41891",
  "campaigns-utils-lib": "static-1.3043",
  "reporting-enablement": "static-1.22434",
  "chatspot-widget-iframe": "static-1.20746",
  "collaboration-sidebar-common": "static-1.2213",
  "forms-ai-lib": "static-1.4140",
  "codemirror-dlb": "static-1.58341",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6314",
  "report-customization-components": "static-1.12790",
  "data-quality-ui-library": "static-1.12555",
  "html-to-image": "static-1.51",
  "reporting-insights-lib": "static-1.1359"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11874",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.305",
  "data-fetching-client": "/data-fetching-client/static-1.9561",
  "foundations-components": "/foundations-components/static-1.7691",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.716",
  "foundations-theming": "/foundations-theming/static-1.4297",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.79",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7897",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9698",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyleTokens": "/HubStyleTokens/static-2-me-set-font-family-mixin.4",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6356",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11935",
  "quartz": "/quartz/static-1.6848",
  "react-dlb": "/react-dlb/static-1.75",
  "react-rhumb": "/react-rhumb/static-1.16540",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2748",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8877",
  "settings-ui-lib": "/settings-ui-lib/static-1.12411",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6923",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11032",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9430",
  "unified-auth": "/unified-auth/static-1.328",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.609",
  "usage-tracker": "/usage-tracker/static-1.7221",
  "usage-tracker-core": "/usage-tracker-core/static-1.7071",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7969",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6105",
  "integrations-lib": "/integrations-lib/static-1.15723",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19244",
  "property-management-iframe": "/property-management-iframe/static-1.12750",
  "quartz-config": "/quartz-config/static-1.626",
  "quartz-core": "/quartz-core/static-1.6067",
  "quartz-routing": "/quartz-routing/static-1.278",
  "quick-fetch": "/quick-fetch/static-1.3819",
  "react": "/react/static-7.183",
  "rpc-client-utils": "/rpc-client-utils/static-1.4529",
  "ts-schema": "/ts-schema/static-1.3983",
  "ui-universal-auth": "/ui-universal-auth/static-1.8814",
  "UIComponents": "/UIComponents/static-3-me-set-font-family-mixin.4",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.425",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven": "/raven/static-3.5808",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3309",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3125",
  "quartz-webpack": "/quartz-webpack/static-1.3072",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3960",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4730",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2013",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9314",
  "react-aria": "/react-aria/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5252",
  "react-virtualized": "/react-virtualized/static-2.96",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1481",
  "ui-fonts": "/ui-fonts/static-1-me-set-font-family-mixin.4",
  "ui-images": "/ui-images/static-2-me-set-font-family-mixin.2",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2780",
  "foundations-theming-base": "/foundations-theming-base/static-1.3282",
  "stylex": "/stylex/static-1.29",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3008",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4210",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8633",
  "ai-rendering-library": "/ai-rendering-library/static-1.9644",
  "chirp-fetch": "/chirp-fetch/static-1.1767",
  "connections-embed-lib": "/connections-embed-lib/static-1.772",
  "copilot-toolkit": "/copilot-toolkit/static-1.10798",
  "laboratory-lib": "/laboratory-lib/static-3.7045",
  "marketplace-embed": "/marketplace-embed/static-1.21737",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9140",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19200",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13415",
  "sanitize-text": "/sanitize-text/static-1.8030",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8581",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5635",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4907",
  "wootric-nps": "/wootric-nps/static-1.6870",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4536",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4038",
  "highcharts": "/highcharts/static-8.101",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "reporting-data": "/reporting-data/static-1.66944",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2-me-set-font-family-mixin.4",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10095",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10259",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7211",
  "icons": "/icons/static-2-me-set-font-family-mixin.2",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17777",
  "storybook-react": "/storybook-react/static-1.30",
  "trellis-story-utils": "/trellis-story-utils/static-1.4405",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5174",
  "quartz-i18n": "/quartz-i18n/static-1.523",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3619",
  "customer-data-objects": "/customer-data-objects/static-1.7540",
  "property-translator": "/property-translator/static-1.5295",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7810",
  "hs-promise-utils": "/hs-promise-utils/static-1.5481",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4764",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13138",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5481",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7672",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4358",
  "superstore": "/superstore/static-1.4654",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10032",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7696",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4556",
  "immutable-less": "/immutable-less/static-1.4538",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16651",
  "nav-meta": "/nav-meta/static-1.29233",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10130",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17810",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3750",
  "property-management-common": "/property-management-common/static-1.5038",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8935",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.523",
  "quartz-head": "/quartz-head/static-1.513",
  "quartz-test": "/quartz-test/static-1.523",
  "quartz-tracking": "/quartz-tracking/static-1.227",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3053",
  "sassPrefix": "/sassPrefix/static-1.153",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20754",
  "ContentUtils": "/ContentUtils/static-1.67964",
  "avatar-components": "/avatar-components/static-1.2380",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39272",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12903",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13039",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13905",
  "ExportDialog": "/ExportDialog/static-6.10275",
  "highlight.js": "/highlight.js/static-1.76",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40927",
  "reporting-snowflake": "/reporting-snowflake/static-1.55562",
  "reporting-ui-components": "/reporting-ui-components/static-2.64215",
  "reporting-visualizations": "/reporting-visualizations/static-1.59020",
  "ui-addon-teams": "/ui-addon-teams/static-1.21386",
  "magpie-lib": "/magpie-lib/static-1.5479",
  "magpie-types": "/magpie-types/static-1.4939",
  "simple-logging-lib": "/simple-logging-lib/static-1.2936",
  "navigation-components": "/navigation-components/static-1.17596",
  "ai-studio-lib": "/ai-studio-lib/static-1.11263",
  "app-governance-lib": "/app-governance-lib/static-1.1177",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10391",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7876",
  "ui-product-approvals": "/ui-product-approvals/static-1.27793",
  "ui-tool-access": "/ui-tool-access/static-1.10032",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8279",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5638",
  "usage-tracker-public": "/usage-tracker-public/static-1.7032",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3494",
  "persist-promise": "/persist-promise/static-1.3594",
  "reference-resolvers": "/reference-resolvers/static-1.8052",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3825",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.223",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2892",
  "final-form": "/final-form/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2443",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4955",
  "purchase-motions-components": "/purchase-motions-components/static-1.5653",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1437",
  "crm-component-utils": "/crm-component-utils/static-1.38737",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5761",
  "customer-data-properties": "/customer-data-properties/static-1.51123",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6761",
  "property-value-citations": "/property-value-citations/static-1.1737",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7975",
  "navigation-messaging": "/navigation-messaging/static-1.6923",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9696",
  "cms-field-types": "/cms-field-types/static-1.4694",
  "content-icons-ui": "/content-icons-ui/static-1.2191",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7134",
  "crm-message-bus": "/crm-message-bus/static-1.42646",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21707",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9710",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4605",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3913",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6666",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.869",
  "onboarding-tours": "/onboarding-tours/static-1.16392",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13336",
  "academy-common-lib": "/academy-common-lib/static-1.13365",
  "content-assistance-lib": "/content-assistance-lib/static-1.7580",
  "dashboard-lib": "/dashboard-lib/static-1.81022",
  "file-manager-components": "/file-manager-components/static-1.23243",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18156",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17889",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17881",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19633",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8579",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4654",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10854",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8925",
  "user-context": "/user-context/static-1.4985",
  "growth-payments-core": "/growth-payments-core/static-1.25007",
  "reporting-plugins": "/reporting-plugins/static-1.10115",
  "reporting-reports": "/reporting-reports/static-1.66622",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.609",
  "nest": "/nest/static-1.107",
  "codemirror": "/codemirror/static-5.92",
  "feedback-loader": "/feedback-loader/static-1.29074",
  "react-codemirror": "/react-codemirror/static-1.10509",
  "framework-listing-lib": "/framework-listing-lib/static-2.28317",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30387",
  "apps-service-types": "/apps-service-types/static-1.3763",
  "oauth-service-types": "/oauth-service-types/static-1.4134",
  "onboarding-scopes": "/onboarding-scopes/static-1.6348",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4606",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7571",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14708",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3515",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8862",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4386",
  "nav-client-types": "/nav-client-types/static-1.2244",
  "purchase-motions-api": "/purchase-motions-api/static-1.5656",
  "signup-constants": "/signup-constants/static-1.18625",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7925",
  "trials-service-types": "/trials-service-types/static-1.3787",
  "card-properties-lib": "/card-properties-lib/static-1.43808",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36747",
  "crm-actions": "/crm-actions/static-1.6200",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43214",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9025",
  "customer-data-tracking": "/customer-data-tracking/static-1.6768",
  "hs-resources": "/hs-resources/static-1.21",
  "pulse": "/pulse/static-1.419",
  "calling-global-api": "/calling-global-api/static-1.64043",
  "calling-internal-common": "/calling-internal-common/static-1.31187",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65425",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57719",
  "commerce-products-lib": "/commerce-products-lib/static-1.9110",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3702",
  "crm-links": "/crm-links/static-1.6160",
  "external-options-client-types": "/external-options-client-types/static-1.4063",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4127",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.516",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3594",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48339",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3869",
  "smart-property-lib": "/smart-property-lib/static-1.6369",
  "tiered-pricing": "/tiered-pricing/static-1.987",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10877",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4047",
  "react-dnd-compat": "/react-dnd-compat/static-1.4504",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5252",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2957",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1564",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.458",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7413",
  "academy-service-client": "/academy-service-client/static-1.3566",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28203",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8268",
  "video-components-external": "/video-components-external/static-1.10885",
  "video-data-lib": "/video-data-lib/static-1.34543",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23194",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9772",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24109",
  "viral-links-lib": "/viral-links-lib/static-1.6923",
  "data-token-picker": "/data-token-picker/static-1.16204",
  "FileManagerLib": "/FileManagerLib/static-1.38883",
  "react-flip-move": "/react-flip-move/static-1.67",
  "timezone-utils": "/timezone-utils/static-2.5129",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17274",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8582",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7209",
  "customer-data-views-management": "/customer-data-views-management/static-1.25186",
  "framework-data-table": "/framework-data-table/static-2.11634",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6735",
  "nudge-client-utils": "/nudge-client-utils/static-1.2332",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.828",
  "app-users-service-client": "/app-users-service-client/static-1.5441",
  "app-users-service-types": "/app-users-service-types/static-1.4849",
  "mini-checkout-client": "/mini-checkout-client/static-1.26530",
  "onboarding-utils": "/onboarding-utils/static-1.5236",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1998",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28188",
  "edison-service-client-types": "/edison-service-client-types/static-1.273",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3068",
  "crm_data": "/crm_data/static-4.91570",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45675",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15487",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18750",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18212",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10061",
  "crm-fe-perf": "/crm-fe-perf/static-1.22788",
  "directed-graph": "/directed-graph/static-1.823",
  "event-emitter": "/event-emitter/static-1.833",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "calling-error-reporting": "/calling-error-reporting/static-1.31193",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10924",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6427",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.541",
  "commerce-permissions": "/commerce-permissions/static-1.650",
  "products-iframe-lib": "/products-iframe-lib/static-1.7597",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10080",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5454",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9781",
  "policy-lib": "/policy-lib/static-1.6669",
  "react-tinymce": "/react-tinymce/static-1.54897",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9844",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54023",
  "tinymce-plugins": "/tinymce-plugins/static-1.57137",
  "tinymce-themes": "/tinymce-themes/static-1.55993",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1768",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1592",
  "user-context-client": "/user-context-client/static-1.4497",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6466",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11842",
  "content-media-compositions": "/content-media-compositions/static-2.15849",
  "media-bridge-lib": "/media-bridge-lib/static-1.18724",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5882",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4972",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3554",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21472",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3729",
  "audio-components": "/audio-components/static-1.5743",
  "FileManagerCore": "/FileManagerCore/static-1.38742",
  "FileManagerImages": "/FileManagerImages/static-1.36394",
  "video-components": "/video-components/static-1.12888",
  "crm-export-dialog": "/crm-export-dialog/static-1.6180",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6322",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1584",
  "tanstack-virtual": "/tanstack-virtual/static-1.27",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2089",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2408",
  "whisper-core-api": "/whisper-core-api/static-1.6252",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14480",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5261",
  "settings-content-modals": "/settings-content-modals/static-1.45734",
  "crm_universal": "/crm_universal/static-1.21805",
  "customer-data-email": "/customer-data-email/static-1.17834",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36791",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39170",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11539",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54319",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21124",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17394",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71535",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5219",
  "utility-belt": "/utility-belt/static-1.2425",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22286",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7303",
  "customer-data-rte": "/customer-data-rte/static-1.32687",
  "cv-backend-services": "/cv-backend-services/static-1.1536",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5505",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4997",
  "qrcode-generator": "/qrcode-generator/static-1.66",
  "quotes-client-types": "/quotes-client-types/static-1.37625",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35318",
  "sales-views-client-types": "/sales-views-client-types/static-1.4149",
  "hub-http-contrib": "/hub-http-contrib/static-1.2928",
  "interframe": "/interframe/static-3.4648",
  "tinymce-data": "/tinymce-data/static-1.40108",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5097",
  "layout-dnd-components": "/layout-dnd-components/static-1.12223",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11198",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14671",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8973",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4417",
  "video-embed": "/video-embed/static-1.35377",
  "social-insights-client-types": "/social-insights-client-types/static-1.21716",
  "deal-intel-utils": "/deal-intel-utils/static-1.1588",
  "checkout-sdk": "/checkout-sdk/static-3.23373",
  "checkout-service-types": "/checkout-service-types/static-1.3731",
  "company-details-components": "/company-details-components/static-1.6072",
  "payment-method-components": "/payment-method-components/static-1.6783",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13169",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3366",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3412",
  "access-control-lib": "/access-control-lib/static-1.10323",
  "EmailComponents": "/EmailComponents/static-1.54417",
  "EmailData": "/EmailData/static-1.53094",
  "redux-less": "/redux-less/static-2.9370",
  "sequences-lib": "/sequences-lib/static-1.7844",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10234",
  "products-ui-components": "/products-ui-components/static-1.39629",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80256",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6878",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54335",
  "commerce-products-api": "/commerce-products-api/static-1.2112",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56393",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102213",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "draft-content-plugins": "/draft-content-plugins/static-1.27955",
  "ContentData": "/ContentData/static-1.68039",
  "layout-data-lib": "/layout-data-lib/static-1.9523",
  "outpost": "/outpost/static-1.4082",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3815",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3874",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18362",
  "pricing-pages-api": "/pricing-pages-api/static-1.13034",
  "ContentComponents": "/ContentComponents/static-2.70920",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9450",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1834",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45895",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.757",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18512",
  "automation-ui-types": "/automation-ui-types/static-1.19430",
  "messaging-types-lib": "/messaging-types-lib/static-1.45632",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4389",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7701",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.405",
  "property-description-translator": "/property-description-translator/static-1.3740",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9060",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3542",
  "totals-ui-components": "/totals-ui-components/static-1.23242",
  "advanced-menus-core": "/advanced-menus-core/static-1.14950",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11914",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33712",
  "demographics-service-types": "/demographics-service-types/static-1.1536",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5346",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7225",
  "data-token-views": "/data-token-views/static-1.16185",
  "forms-utils-lib": "/forms-utils-lib/static-1.12361",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12801",
  "simple-menus-core": "/simple-menus-core/static-1.14949",
  "simple-menus-lib": "/simple-menus-lib/static-1.16466",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4139",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6655",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3406",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2548",
  "ContentEditorUI": "/ContentEditorUI/static-2.76782",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3873",
  "web-interactives-components": "/web-interactives-components/static-1.13564",
  "web-interactives-data": "/web-interactives-data/static-1.13565",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.206",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.376",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.862",
  "FireAlarmUi": "/FireAlarmUi/static-1.4414",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4071",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3721",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21366",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20829",
  "data-studio-ubb": "/data-studio-ubb/static-1.2380",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26680",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57416",
  "content-management-data-lib": "/content-management-data-lib/static-1.5240",
  "copilot-plugins": "/copilot-plugins/static-1.10771",
  "cta-picker": "/cta-picker/static-1.36089",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2714",
  "editor-components": "/editor-components/static-1.13064",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8244",
  "error-messaging-js": "/error-messaging-js/static-1.5076",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85530",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.62",
  "redux-request-state": "/redux-request-state/static-1.10531",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1638",
  "smart-content-core": "/smart-content-core/static-1.42116",
  "smart-content-lib": "/smart-content-lib/static-1.42769",
  "social-composer-lib": "/social-composer-lib/static-1.58506",
  "structured-content-lib": "/structured-content-lib/static-1.24871",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52925",
  "tinymce-copilot": "/tinymce-copilot/static-1.16091",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7735",
  "automation-ui-routing": "/automation-ui-routing/static-1.20787",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5550",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41891",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3043",
  "reporting-enablement": "/reporting-enablement/static-1.22434",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20746",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2213",
  "forms-ai-lib": "/forms-ai-lib/static-1.4140",
  "codemirror-dlb": "/codemirror-dlb/static-1.58341",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6314",
  "report-customization-components": "/report-customization-components/static-1.12790",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12555",
  "html-to-image": "/html-to-image/static-1.51",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1359"
}
};
